import { BrandTheme } from '@blockpulse3/ui/brand-theme';

import { accordionTheme } from './components/accordion';
import { alertTheme } from './components/alert';
import { cardTheme } from './components/card';
import { checkboxTheme } from './components/checkbox';
import { modalTheme } from './components/modal';
import { popoverTheme } from './components/popover';
import { radioTheme } from './components/radio';
import { tabsTheme } from './components/tabs';

const Alert = alertTheme;
const Card = cardTheme;
const Tabs = tabsTheme;
const Checkbox = checkboxTheme;
const Radio = radioTheme;
const Accordion = accordionTheme;
const Modal = modalTheme;
const Popover = popoverTheme;

const Avatar = {
  baseStyle: {
    container: {
      bg: 'gray.100',
      color: 'gray.800',
    },
  },
};

const Badge = {
  baseStyle: {
    borderRadius: '10px',
    px: 2,
    textTransform: 'none',
    fontSize: 'sm',
    fontWeight: '500',
  },
  variants: {
    radio: {
      p: 3,
      backgroundColor: 'gray.50',
      borderRadius: 'none',
    },
  },
};

const Button = {
  variants: {
    'primary': {
      'bg': 'secondary',
      'color': 'white',
      'rounded': BrandTheme.borderRadius.button,
      '_disabled': {
        opacity: 0.7,
      },
      '_hover': {
        opacity: 0.7,
      },
      '&:disabled:hover': {
        background: 'secondary',
        opacity: 0.7,
      },
    },
    'secondary': {
      'bg': 'gray.100',
      'color': 'gray.800',
      'rounded': BrandTheme.borderRadius.button,
      '_disabled': {
        opacity: 0.7,
      },
      '_hover': {
        bg: 'gray.200',
      },
      '&:disabled:hover': {
        background: 'gray.200',
        opacity: 0.7,
      },
    },
    'light': {
      bg: 'white',
      p: '4',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'gray.300',
      borderRadius: '3px',
      whiteSpace: 'normal',
      _hover: {
        bg: 'blackAlpha.50',
      },
    },
    'link': {
      bg: 'transparent',
      color: 'secondary',
      _active: {
        color: 'secondary',
      },
    },
    'menu-button': {
      w: 'full',
      p: '2',
      justifyContent: 'start',
      userSelect: 'none',
      outline: 0,
      transition: 'all 0.2s',
      _active: {
        bg: 'whiteAlpha.400',
      },
      _hover: {
        bg: 'whiteAlpha.400',
      },
      _focus: {
        shadow: 'none',
      },
    },
    'item': {
      w: 'full',
      h: 'full',
      p: 5,
      rounded: 'none',
      borderWidth: '0 0 1px 0',
      borderStyle: 'solid',
      borderColor: 'gray.200',
      justifyContent: 'flex-start',
      _active: {
        backgroundColor: 'gray.50',
      },
      _hover: {
        backgroundColor: 'gray.100',
      },
      _focus: {
        shadow: 'none',
      },
    },
    'workspace': {
      //w: 'full',
      bg: 'transparent',
      minW: 10,
      p: 0,
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'whiteAlpha.300',
      _active: {
        bg: 'whiteAlpha.300',
        borderWidth: '0',
      },
      _hover: {
        bg: 'whiteAlpha.300',
        borderWidth: '0',
      },
      _focus: {
        shadow: 'none',
      },
    },
    'container': {
      display: 'flex',
      justifyContent: 'start',
      w: 'full',
      h: 'full',
      p: 4,
      bg: 'white',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'gray.300',
      borderRadius: '3px',
      boxShadow: 'md',
      whiteSpace: 'normal',

      textAlign: 'start',
      _hover: {
        bg: 'blackAlpha.50',
      },
    },
    'delete': {
      'bg': 'red.600',
      'color': 'white',
      'rounded': BrandTheme.borderRadius.button,
      '_hover': {
        bg: 'red.400',
      },
      '_active': {
        bg: 'red.400',
      },
      '&:disabled:hover': {
        bg: 'red.400',
      },
    },
  },
  defaultProps: {
    variant: 'primary',
  },
};

const Heading = {
  baseStyle: {
    fontWeight: 'semibold',
  },
};

const Text = {
  variants: {
    ellipsis: {
      overflowX: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
};

const Divider = {
  baseStyle: {
    borderColor: 'gray.300',
  },
  variants: {
    'menu-button': {
      bg: 'whiteAlpha.600',
      height: '1px',
    },
  },
};

const Input = {
  parts: ['field', 'addon'],
  variants: {
    outline: {
      field: {
        bg: 'white',
      },
      addon: {
        background: 'gray.50',
      },
    },
  },
  defaultProps: {
    focusBorderColor: 'secondary',
  },
};

const Progress = {
  parts: ['filledTrack'],
  defaultProps: {
    filledTrack: {
      bg: 'green.600',
    },
  },
};

const Table = {
  parts: ['th', 'thead', 'tbody'],
  variants: {
    striped: {
      th: {
        color: 'gray.500',
        fontWeight: 500,
        bg: 'gray.50',
        borderColor: 'gray.300',
      },
      tbody: {
        '& tr:nth-of-type(even) td': {
          background: 'gray.50',
        },
        '& tr:nth-of-type(odd) td': {
          background: 'white',
        },
      },
    },
  },
};

const Drawer = {
  defaultProps: {
    size: 'sm',
  },
};

export const components = {
  Alert,
  Avatar,
  Badge,
  Button,
  Card,
  Heading,
  Input,
  Divider,
  Accordion,
  Modal,
  Drawer,
  Progress,
  Tabs,
  Text,
  Table,
  Checkbox,
  Radio,
  Popover,
};
